<!-- Sino de notificacoes (visivel apenas com o privilegio "Gestao do Contador") -->
<ng-container *ngIf="podeVer">
<span class="p-overlay-badge">
  <button
    pButton
    type="button"
    icon="pi pi-bell"
    class="p-button-sm p-button-text p-button-rounded notif-bell-btn"
    [attr.aria-label]="'notificacoes.titulo' | translate"
    (click)="op.toggle($event); carregar()">
  </button>
  <span
    *ngIf="totalPendencias > 0"
    pBadge
    [value]="totalPendencias > 99 ? '99+' : totalPendencias.toString()"
    severity="danger">
  </span>
</span>

<!-- Dropdown com a lista -->
<p-overlayPanel #op [style]="{ width: '340px' }" styleClass="notif-panel">
  <div class="notif-header">
    <i class="pi pi-bell"></i>
    <span class="notif-header-titulo">{{ 'notificacoes.titulo' | translate }}</span>
    <span class="notif-header-count" *ngIf="totalPendencias > 0">{{ totalPendencias }}</span>
  </div>

  <div class="notif-vazio" *ngIf="totalPendencias === 0 && !carregando">
    <i class="pi pi-inbox"></i>
    <span>{{ 'notificacoes.vazio' | translate }}</span>
  </div>

  <div class="notif-lista">
    <!-- Solicitacoes de contrato -->
    <button type="button" class="notif-item" *ngFor="let s of solicitacoes" (click)="abrirNotificacoes(op)">
      <span class="notif-item-icon"><i class="pi pi-file-edit"></i></span>
      <span class="notif-item-info">
        <span class="notif-item-titulo">{{ 'notificacoes.contrato.titulo' | translate }}</span>
        <span class="notif-item-sub">
          {{ 'notificacoes.contrato.de' | translate }} <strong>{{ s.nomeContador || '-' }}</strong>
          &middot; {{ s.percentualDesconto }}%
        </span>
      </span>
      <i class="pi pi-angle-right notif-item-arrow"></i>
    </button>

    <!-- Despesas acessorias pendentes de aprovacao -->
    <button type="button" class="notif-item" *ngFor="let d of despesas" (click)="abrirNotificacoes(op)">
      <span class="notif-item-icon"><i class="pi pi-wallet"></i></span>
      <span class="notif-item-info">
        <span class="notif-item-titulo">{{ 'notificacoes.despesa.titulo' | translate }}</span>
        <span class="notif-item-sub">
          {{ 'notificacoes.contrato.de' | translate }} <strong>{{ d.nomeContador || '-' }}</strong>
          &middot; {{ d.valor | guaraniFormat }}
        </span>
      </span>
      <i class="pi pi-angle-right notif-item-arrow"></i>
    </button>
  </div>
</p-overlayPanel>
</ng-container>
